import { createStore } from 'vuex';
import locale from './modules/locale';
import home from './modules/home';
import docs from './modules/docs';

export default createStore({
  modules: {
    locale,
    home,
    docs,
  },
  strict: process.env.NODE_ENV !== 'production',
});

